
import StockOperationPage from '../pages/stock/StockOperationPage'
import StockReportPage from '../pages/stock/StockReportPage'
import StockTransactionAuditPage from '../pages/stock/StockTransactionAuditPage'

const routes = [
    {
        name: 'StockOperationPage',
        path: '/stock/operation',
        component: StockOperationPage,
        meta: {
            requiresAuth: true,
            permission: "STOCK_UPDATE"
        }
    },

    {
        name: 'StockReportPage',
        path: '/stock/report',
        component: StockReportPage,
        meta: {
            requiresAuth: true,
            permission: "STOCK_SHOW",
            disableFooter: true
        }
    },

    {
        name: 'StockTransactionAuditPage',
        path: '/stock/transaction/audit',
        component: StockTransactionAuditPage,
        meta: {
            requiresAuth: true,
            permission: "STOCKTRANSACTION_AUDIT_VIEW"
        }
    },


]

export default routes;
